<script>
import { mapGetters } from 'vuex'
export default
{
    name: 'mv-supporter-category-form',

    computed:
    {
        ...mapGetters({
            locale: 'generalCurrentLocale',
        }),

    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }
        },
    },

    props:
    {
        model: Object,
        edit: Boolean,
    }

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('ARTIST.NAME') }}
            </label>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">
                        <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.name">
                </div>
            </div>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2">
                        <img src="/static/us-flag.png" alt="English" title="English" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.name_en" >
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="order" class="col-md-4 control-label">
                {{ $t('MENUS.ORDER') }}
            </label>
            <div class="col-md-6">
                <input type="number" class="form-control" v-model="model.order" >
            </div>
        </div>
    </form>
</div>
</template>


// WEBPACK FOOTER //
// src/components/forms/SupporterCategoryForm.vue